// extracted by mini-css-extract-plugin
module.exports = {"labels-layout":"_02712f2b3b--labels-layout--v_EuM","label":"_02712f2b3b--label--DZaI2","tooltip":"_02712f2b3b--tooltip--wsF9D"};